import {
  callInField,
  CoverageSnippet,
  FieldMap,
  getBasicInfoField,
  policyOwnerFieldMap,
  PregnancyCoverageLabel,
} from '@hb/shared'

export const coverageSnippetStage: Record<CoverageSnippet, (medicaid: boolean) => FieldMap> = {
  'basic-info': getBasicInfoField,
  'call-in': () => callInField,
  'policy-owner': () => policyOwnerFieldMap,
}
export const getAssessmentCoverageDataPath = (
  pregnancyCoverageId: PregnancyCoverageLabel | null,
) => {
  if (!pregnancyCoverageId) return null
  if (pregnancyCoverageId === 'primary') return 'insuranceInfo.primaryCoverage'
  if (pregnancyCoverageId === 'secondary') return 'insuranceInfo.secondaryCoverage'

  return null
}
